exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".desktop-header{background-color:#464a53}.desktop-header::after{display:table;content:\"\";clear:both}.desktop-header h1{float:left;font-size:32px;font-weight:500;font-style:normal;font-stretch:normal;line-height:68px;color:#fff}.desktop-header .user-nav{float:right}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??postcss!./node_modules/sass-loader/dist/cjs.js!./src/routes/main/userprofile/desktop-header/style.scss
// module id = 1266
// module chunks = 62